module.exports = __webpack_public_path__ + "img/a3.09fe6ae8.jpg";